var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInputError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4661_1624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 14.1667C10.2355 14.1667 10.4334 14.0868 10.5931 13.9271C10.7528 13.7674 10.8327 13.5694 10.8327 13.3333C10.8327 13.0972 10.7528 12.8993 10.5931 12.7396C10.4334 12.5799 10.2355 12.5 9.99935 12.5C9.76324 12.5 9.56532 12.5799 9.4056 12.7396C9.24588 12.8993 9.16602 13.0972 9.16602 13.3333C9.16602 13.5694 9.24588 13.7674 9.4056 13.9271C9.56532 14.0868 9.76324 14.1667 9.99935 14.1667ZM9.16602 10.8333H10.8327V5.83332H9.16602V10.8333ZM9.99935 18.3333C8.84657 18.3333 7.76324 18.1146 6.74935 17.6771C5.73546 17.2396 4.85352 16.6458 4.10352 15.8958C3.35352 15.1458 2.75977 14.2639 2.32227 13.25C1.88477 12.2361 1.66602 11.1528 1.66602 9.99999C1.66602 8.84721 1.88477 7.76388 2.32227 6.74999C2.75977 5.7361 3.35352 4.85416 4.10352 4.10416C4.85352 3.35416 5.73546 2.76041 6.74935 2.32291C7.76324 1.88541 8.84657 1.66666 9.99935 1.66666C11.1521 1.66666 12.2355 1.88541 13.2494 2.32291C14.2632 2.76041 15.1452 3.35416 15.8952 4.10416C16.6452 4.85416 17.2389 5.7361 17.6764 6.74999C18.1139 7.76388 18.3327 8.84721 18.3327 9.99999C18.3327 11.1528 18.1139 12.2361 17.6764 13.25C17.2389 14.2639 16.6452 15.1458 15.8952 15.8958C15.1452 16.6458 14.2632 17.2396 13.2494 17.6771C12.2355 18.1146 11.1521 18.3333 9.99935 18.3333ZM9.99935 16.6667C11.8605 16.6667 13.4369 16.0208 14.7285 14.7292C16.0202 13.4375 16.666 11.8611 16.666 9.99999C16.666 8.13888 16.0202 6.56249 14.7285 5.27082C13.4369 3.97916 11.8605 3.33332 9.99935 3.33332C8.13824 3.33332 6.56185 3.97916 5.27018 5.27082C3.97852 6.56249 3.33268 8.13888 3.33268 9.99999C3.33268 11.8611 3.97852 13.4375 5.27018 14.7292C6.56185 16.0208 8.13824 16.6667 9.99935 16.6667Z",
    fill: "#F30000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4661_1624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/input_error.47ac3add8fad714d37dfc39438359649.svg";
export { ForwardRef as ReactComponent };